module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "cn",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062568366_Contents#r_idParaDest-4"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("Chapter 3")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It was indeed Jathon Anderthon, my sworn enemy and the son of Thackary Anderthon (who was my even bigger enemy). His blond hair was dusty, and the kid no longer had a beard. That consequence must have worn off. Clenched tightly in his right hand was an empty glass pickle jar. I recognized it from my first quest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s Jathon,” Ridge whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see that,” I said. “Why does he have a pickle jar? Do you think he’s a Wishmaker again?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That would be highly unlikely,” Ridge said. “I’m guessing he carries it around for sentimental reasons.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Or because he likes pickles,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I stopped the dinosaur bot,” Jathon announced. “You can thank me later.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You?” I cried. “What could you possibly do against a giant robot Tyrannosaurus rex?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("“It was easy,” he said. “I flipped the Off switch on its back.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“THERE WAS AN OFF SWITCH?” I shrieked in frustration.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well,” Jathon continued, “I had to wish for it, of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So, you "), _c('i', [_vm._v("are")]), _vm._v(" a Wishmaker again,” I said, pointing at his jar.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ridge stepped forward, fists clenched. “You monster! Let that genie out of her jar!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Last time, Jathon had kept his genie bottled up for most of the week. I didn’t know what it was like inside a jar. Ridge said it was like a peaceful deep sleep between quests. But putting your genie inside a jar while they were assigned to a Wishmaker was apparently some kind of itchy, unpleasant experience.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My genie isn’t in her jar.” Jathon gestured behind him as his genie stepped out from behind the rubble of the T. rex’s tail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, guys.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Vale?” Ridge and I cried in unison.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The redheaded genie girl stood with both hands in the pockets of her hoodie, somehow managing to look slightly bored while surrounded by the wreckage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But that’s . . .” I stammered. “She’s not . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Vale is Tina’s genie!” Ridge finally managed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know that’s not how it works,” Vale said. “The Universe assigns us wherever we’re needed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have so many questions right now.” I put a hand to my head. “What are you two even doing here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v("“I’m wondering the same about you,” said Jathon.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We glared at each other for a moment. “You go first,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You go first,” Jathon replied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. You go first.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Rock, paper, scissors?” Ridge suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I shot him a dirty glare. Tina had tricked me before with that game. I wasn’t going to risk playing it ever again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fine. I’ll explain.” I took a deep breath. “Tina wished for her mom’s necklace to be a trinket that would reunite me with Ridge once I broke it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s with the dinosaur?” Vale asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve actually been wondering the same thing,” Ridge whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Robo Rex was a side effect,” I explained. “Apparently, Ms. Gomez’s necklace was already a trinket. Breaking the chain made two wishes come true. It brought me Ridge’s jar, but it also summoned that destructo robot.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hmm,” Jathon mused. “So you tricked the Universe? You two aren’t really supposed to be back together?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, we are,” I spat. I hadn’t thought of it that way. “This was Tina’s idea, anyway. We have to help her get away from Chasm.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s why we’re here,” Jathon replied. “The Universe sent me this genie jar yesterday. I was going to have some pickles "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("with my grilled cheese sandwich. I got Vale instead.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Equally sour,” Ridge muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I turned to Vale. “Don’t you live inside a little jar of lip balm?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That was just how Tina found me,” she answered. “The Universe disguises our jars to look like something the Wishmaker would want to open. Apparently, Jathon eats a lot of pickles.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’re delicious, okay?” the boy defended.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Calm down,” said Ridge. “What’s the big "), _c('i', [_vm._v("dill")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is it common for the Universe to send another genie to someone who has already been a Wishmaker?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” answered Vale. “I’ve never heard of it happening. But with Chasm on the loose, the Universe must be desperate enough to try something new.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have to free Tina from Chasm,” Jathon said. “And I only have six more days to do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That sounds like a quest,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is,” Jathon answered. “My quest is to separate a genie from a Wishmaker. The Universe needs me to save Tina.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What happens if you fail?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If I don’t free Tina by the end of the week, then the air is going to turn into chocolate sauce.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Delicious!” Ridge cried.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_vm._v("“What about breathing?” I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think that’s sort of the point,” Jathon said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Another quest with a world-ending consequence,” Vale said. “The Universe knows it can count on Jathon Anderthon.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What about me?” I turned to Ridge. “Do I have a new quest?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, you do!” He snapped his fingers. “And I’m so glad you mentioned it. That totally slipped my mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What is it?” I asked, shuffling my feet nervously in the littered aisle. “Am I supposed to find Tina, too? What does the Universe need me to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You must make a peanut butter and jelly sandwich and feed it to a person named Samuel Sylvester Stansworth,” Ridge answered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What is it with the Universe and peanut butter?” I cried. “That sounds like the easiest quest ever!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Unless the guy hates sandwiches,” Ridge pointed out. “Or what if he’s allergic to peanuts?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What does it matter?” I asked. “I don’t see what any of this has to do with saving Tina.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This quest wasn’t any stranger than my first, when I’d been told to find Thackary Anderthon and stop him from opening Chasm’s jar.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Neither do I,” Ridge admitted. “But that’s the quest that the Universe assigned you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("“That’s ridiculous!” I shouted, feeling my cheeks turning red with embarrassment. “How’s that supposed to help Tina? Make a peanut butter sandwich for some random guy. . . .”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Samuel Sylvester Stansworth,” Ridge reminded me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I took a deep breath. The quest wasn’t what I’d been hoping for, but the Universe had to give me this assignment for a good reason, right? “What happens if I don’t succeed?” I asked. “Will the whole world burn up? Will it rain deadly shards of metal?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ridge wrinkled his forehead as though trying to figure out a difficult math problem. “If you don’t succeed . . .” He paused. “Then all the red roses in the world will lose their smell.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stared, speechless. But Vale and Jathon both chuckled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All the red roses will lose their smell?” I repeated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yup.” Ridge nodded. “Really not too bad, considering last time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No!” I cleared my throat. “That’s dumb. I got you back so I could free Tina. That’s what we’re going to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What about the consequence?” Ridge asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who cares?” I threw my hands up. “Unscented roses aren’t going to hurt anyone.” Insulted by the Universe’s lack of trust in me, I turned to Jathon and Vale.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I assume you’re here because you have a lead on how to save Tina?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jathon nodded. “I made a wish to find out if anyone knew "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_vm._v("how to separate a genie from a Wishmaker.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just wait until the week runs out,” Ridge said. “The Universe separates us when the quest ends.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vale shook her head. “Chasm’s different. Tina doesn’t have a quest while she’s tethered to him. And he said that the two of them would be together until Tina died.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is there a way?” I asked. “Some way to cut Tina free and send Chasm back into his jar?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We don’t know how,” Vale admitted. “But the Universe told us about someone who does.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re looking for a person called the Trinketer,” said Jathon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And you thought you’d check the grocery store?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wished to know where the Trinketer would be at noon today,” Jathon said. “The answer led me here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How is the Trinketer supposed to help?” Ridge asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Going by her title, she might know about some trinkets capable of freeing a Wishmaker from a genie,” answered Vale. “Just what Tina needs.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then we’d better find her,” I said. “There were a lot of people in the store. Any idea what this Trinketer looks like?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I guess we should figure that out,” said Jathon, turning to Vale. “I wish to know what the Trinketer looks like.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I saw his watch turn into an hourglass as Vale spelled things "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_vm._v("out. “If you want to know what the Trinketer looks like,” she said, “then every time you look in a mirror, it will break.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whoa,” Ridge said. “Doesn’t that bring you bad luck?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How long will it last?” Jathon asked, ignoring Ridge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“One month,” answered Vale.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll take it,” he said. “Bazang.” His hourglass disappeared and he suddenly had the answer. “The Trinketer is a woman,” Jathon said. “About this tall.” He held up his hand. “Black hair, dark complexion. She wears a thin gold necklace.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sighed heavily. “Used to,” I corrected.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She "), _c('i', [_vm._v("used to wear")]), _vm._v(" a thin gold necklace,” I explained. “The Trinketer is Maria Gomez. Tina’s mom.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aac86c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062568366_Chapter_3.vue
// module id = 72
// module chunks = 0